import { Global } from '@emotion/react'
import { InkCompileMessage } from '@ink'
import { createInlineInkStyles } from './createInlineInkStyles'

export const InlineInkStyles = ({
  messages,
}: {
  messages: InkCompileMessage[]
}) => <Global styles={createInlineInkStyles(messages)} />
